import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BRAND_CONFIG } from '@core/injection-tokens';
import { MultilingualService } from '@core/services';
import { BrandConfig } from '@models/interfaces';

@Component({
  selector: 'app-delete-account-dialog',
  templateUrl: './delete-account-dialog.component.html',
  styleUrls: ['./delete-account-dialog.component.scss'],
  standalone: false,
})
export class DeleteAccountDialogComponent {
  
  get appName(): string {
    return this.brandConfig.displayName;
  }

  constructor(
    public dialogRef: MatDialogRef<DeleteAccountDialogComponent>,
    public readonly multilingualService: MultilingualService,
    @Inject(BRAND_CONFIG) private readonly brandConfig: BrandConfig,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close({ data: true });
  }
}
